import { createAction, props } from '@ngrx/store';
import { News, PageData } from '../../models';

export const LoadNews = createAction('[Content] Load News', props<{ profileId?: number; take?: number; skip?: number }>());
export const LoadNewsSuccess = createAction('[Content] Load News Success', props<{ news: { items: News[]; page: PageData } }>());
export const LoadNewsFail = createAction('[Content] Load News Fail', props<{ error: any }>());

export const LoadNewsOverview = createAction('[Content] Load News Overview', props<{ profileId?: number; take?: number; skip?: number }>());
export const LoadNewsOverviewSuccess = createAction(
  '[Content] Load News Overview Success',
  props<{ news: { items: News[]; page: PageData } }>()
);
export const LoadNewsOverviewFail = createAction('[Content] Load News Overview Fail', props<{ error: any }>());

export const ResetNews = createAction('[Content] Reset News');

export const LoadNewsDetail = createAction('[Content] Load News Detail', props<{ id: number }>());
export const LoadNewsDetailSuccess = createAction('[Content] Load News Detail Success', props<{ news: News }>());
export const LoadNewsDetailFail = createAction('[Content] Load News Detail Fail', props<{ error: any }>());
